export const FORM_ACTIONS = {
  UPDATE_FORM_FIELD: "UPDATE_FORM_FIELD",
  UPDATE_FORM_DATA: "UPDATE_FORM_DATA",
  RESET_FORM_STATE: "RESET_FORM_STATE",
};

export const INITIAL_FORM_STATE = {
  _id: "",
  name: "",
  description: "",
  code: "",
  discountPercentage: 0,
  discountFixedPrice: 0,
  validFrom: "",
  validTo: "",
  active: true,
  minimumBasketPrice: 0,
  maximumDiscountPrice: 0,
  amount: 0,
  isPrivate: null,
  isOneTimeUse: 1,
  type: [],
  suppliers: null,
  category: null,
  products: null,
  brand: null,
  sub_category: null,
  free_delivery: 0,
  free_delivery_bucket_value: 0,
  used_qty: 1,
  valid_date: 0,
  validity_type: "day",
  template_use_for: "template"
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case FORM_ACTIONS.UPDATE_FORM_FIELD: {
      let { name, value } = action.payLoad;
      return  { ...state, [name]: value };
    }
    case FORM_ACTIONS.UPDATE_FORM_DATA: {
      return  { ...state, ...action.payLoad };
    }
    case FORM_ACTIONS.RESET_FORM_STATE: {
      return  INITIAL_FORM_STATE;
    }
  }
};
